import React, { useState } from 'react';
import { Box } from '@material-ui/core';
import styled from 'styled-components';

import { MobileButton } from '../buttons/MobileButton';

import { NavigationContent } from './NavigationContent';

interface IProps {
    className?: string;
}

const BaseNavigation = ({ className }: IProps) => {
    const [mobileNavOpen, setMobileNavOpen] = useState(false);

    const handleMobileNavOpen = () => {
        document.body.style.overflow = 'hidden';

        setMobileNavOpen(true);
    };

    const handleMobileNavClose = () => {
        document.body.style.overflow = '';

        setMobileNavOpen(false);
    };

    return (
        <Box className={className}>
            <MobileButton onClick={handleMobileNavOpen} />

            <NavigationContent
                className={mobileNavOpen ? 'open' : ''}
                onClose={handleMobileNavClose}
            />
        </Box>
    );
};

export const Navigation = styled(BaseNavigation)`
    display: flex;

    ${MobileButton} {
        display: block;
        margin-left: auto;
    }

    ${NavigationContent} {
        &.open {
            right: 0;
        }
    }

    @media (min-width: ${({ theme }) =>
            `${theme.breakpoints.values['md']}px`}) {
        width: 100%;
        height: 100%;

        ${MobileButton} {
            display: none;
        }
    }
`;
